module.exports = __webpack_public_path__ + "static/img/eiffel.cbfaf5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/eiffel.jpg
// module id = Wem0
// module chunks = 1